// extracted by mini-css-extract-plugin
export default {"numberInputContainer":"O6KnPM"};